import { FieldProps, getIn } from 'formik';
import { useCallback } from 'react';

import { SelectAutocomplete } from '@shared/inputs/SelectAutocomplete';
import { IOption } from '@shared/interfaces';
import { ISelectProps } from '../inputs/Select';

export interface ISelectFieldProps extends FieldProps, ISelectProps {
  backgroundColor?: string;
  isCreatable?: boolean;
  canBeClean?: boolean;
  customMessage?: {
    message: string, 
    color: string, 
    textTransform?: string,
    textAlign?: string,
  };
  highlightFullBorder?: boolean;
  defaultValue?: IOption<unknown>;
  checkboxes: boolean;
}

export const SelectAutocompleteField = ({
  field,
  form,
  backgroundColor,
  isCreatable = false,
  canBeClean = true,
  customMessage = {
    message: '',
    color: '',
    textTransform: '',
    textAlign: ''
  },
  highlightFullBorder = false,
  ...props
}: ISelectFieldProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const handleChange = useCallback(
    (value: unknown) => {
      field.onChange({
        target: {
          name: field.name,
          value,
        },
      });

      props.onChange?.(value);
    },
    [field, props],
  );
  
  return (
    <SelectAutocomplete
      {...field}
      {...props}
      canBeClean={canBeClean}
      isCreatable={isCreatable}
      options={props?.options}
      backgroundColor={backgroundColor}
      error={touched && !!error}
      helperText={(touched && error) || ''}
      customMessage={customMessage}
      highlightFullBorder={highlightFullBorder}
      onChange={handleChange}
    />
  );
};
